export default __webpack_public_path__ + "src/assets/images/multiple_photos.png";